var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home centered"},[_c('div',{staticClass:"box"},[_c('FormObject',{attrs:{"form_function":"proccess_details","id":_vm.id}})],1),_c('h3',[_vm._v("משימות / פגישות")]),_c('Tickets',{attrs:{"proccess_id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }